// extracted by mini-css-extract-plugin
export default {"search":"SearchScreen_search__brF0X"};